const $ = require('jquery');

import run from '../../../utilities/run';
import _ from "underscore";
import render from "../../../utilities/render";
import {
    setElementsFromScope
} from "../../../utilities/selectorHelpers";
import SubmitModalFlow from "../../../components/SubmitModalFlow/SubmitModalFlow";
import moment from "moment";
import { createPreventDefault, isPresent, isBlank} from '../../../utilities/general';
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT, SUCCESS_MODAL_TIMEOUT } from "../../../constants";
import fileUploader from '../../../components/fileuploader/index';

const targetSelector = "#packageDetailsForm";

run(targetSelector, () => {
    const sharedModalHtml = require("../../../sharedHtml/modal.html");
    const statusHistoryRowTemplate = require('./html/statusHistoryRow.html');
    const statusRowTemplate = require('./html/statusRow.html');
    const shipmentDetailsRowTemplate = require('./html/shipmentDetailsRow.html');
    const shippingDocSectionRowTemplate = require('./html/shippingDocSection.html');
    const shippingDocFileNameRowTemplate = require('./html/fileNameRow.html');
    const deliveryDetailsRowTemplate = require('./html/deliveryDetailsRow.html');
    const modalOrderBody = require("./html/modalOrderBody.html");
    const shipmentHistoryMissingTemplate = require('./html/shipmentHistoryMissing.html');
    const fileNameRowMissingTemplate = require('./html/fileNameRowMissing.html');
    const uploadShippingDocsModalBodyHtml = require("./html/uploadShippingDocsModalBody.html");
    const modalHtml = require("../../../sharedHtml/modal.html");

    const goToSummaryPageURL = $(targetSelector).data("search-summary-by-oder-url");
    const backToList = $(targetSelector).data("back-to-list");
    const backTosearch = $(targetSelector).data("back-to-search");
    let userRoles = $(targetSelector).data("user-roles");
    let getShippingDocuments = $(targetSelector).data("pod-url");
    const uploadFileUrl = $(targetSelector).data("upload-file-url");

    const elementsMap = {
        orderIdNumberBtn: ".order-id-number"
    };
    const elementsMapModal = {
        goToSummaryPageBtn: ".go-to-summary-btn"
    };

    let packageDetailsForm = $(targetSelector).data("package-details");
    let flag = $(targetSelector).data("flag");
    let packageCount = $(targetSelector).data("package-count");
    let shpDocDetails = $(targetSelector).data("shipping-doc-details");
    const downloadFileByDocIdUrl = $(targetSelector).data("download-by-doc-url");
    const downloadFileUrl = $(targetSelector).data("download-file-url");
    const deleteFileByDocIdUrl = $(targetSelector).data("delete-by-doc-url");
    let frightFlag = $(targetSelector).data("fright-flag");
    let facilityNo = packageDetailsForm.merchantBuId; 
    let wmOrderNo= packageDetailsForm.shipment[0].OrderId; 
    

    let orderIdNumberModal;
    let dummyData = null;
    let shipmentDocsFileUploadModal="";
    
    const els = {};
    const elsModal = {};
    const mainEl = $(render(
        require("./html/podPackageDetailsScreen.html"), {
            statusHistoryWrap: getStatusHistoryData(),
            flag: flag,
            shipDate: shipmentShipDate(),
            trackingNumber: shipmentTrackingNumber(),
            shipmentStatusrenderRow: shipmentStatusrenderRow(),
            shipmentDetailsRow: shipmentDetailsRow(),
            deliveryDetailsRow: deliveryDetailsRow(),
            shippingDocSection: shippingDocSectionRow()
        }
    ));

    $(targetSelector).append(mainEl);

    let submitModalFlow = new SubmitModalFlow();
    submitModalFlow.init();

    function init() {
        generateModals();
        setElements();
        setElementsInModals();
        bindElements();
        getStatusHistoryData();
        shipmentStatusrenderRow();
        shipmentDetailsRow();
        deliveryDetailsRow();
        shippingDocSectionRow();
        shipmentTrackingNumber();
        shipmentBol();
        shipShipmentNumber();
        shipperCarrier();
        handleButtons();
    }

    function setElements() {
        setElementsFromScope(els, elementsMap, mainEl);
    }

    function setElementsInModals() {
        setElementsFromScope(elsModal, elementsMapModal, orderIdNumberModal);
    }

    function bindElements() {
        els.orderIdNumberBtn.click(createPreventDefault(showOrderIdNumberModel));
        elsModal.goToSummaryPageBtn.click(createPreventDefault(goToSummaryPage));
    }

    function handleButtons(){
      if((_.contains(userRoles, "POD Admin") || _.contains(userRoles, "POD User")) && !(_.contains(userRoles, "System Admin"))){
        $(".upload-shipping-doc-btn").attr('disabled', true);
        $(".remove-doc-row-btn").hide();
      }else{
        $(".upload-shipping-doc-btn").attr('disabled', false);
        $(".remove-doc-row-btn").show();
      }
    }

    function shallAllowClick(currentObj){
      return 	!($(currentObj).hasClass("disabled"));
    }

    $(".upload-shipping-doc-btn").on("click", function () {
      generateSharedModal();
      });

    $("#podBtn").on("click", function () {
          const url = `${getShippingDocuments}&shipmentBOL=${shipmentBol()}&trackingNumber=${shipmentTrackingNumber()}
          &shipperCarrier=${shipperCarrier()}`
          submitModalFlow.showLoadingModal();
          $.ajax({
            url: url,
            type: 'POST',
            dataType: "JSON",
            data: "",
            success: onSuccessDisplay,
            error: onFailureDisplay
          });

        });

     //Modal to display when no POD available.

     const noPODAvailableErrorModal = $(render(
        modalHtml,
        {
          title: 'Proof Of Delivery',
          leftAlignTitle: true,
          body: '<div class="q-pad-all-xl">The signed Proof Of Delivery document is not available.</div>',
          topCloseBtn: true,
          autoHideTop: true,
          footerBtns: `
            <a href="#" class="base-btn purple-btn modal-auto-hide">Close</a>
          `
        }
      ));    

    function onSuccessDisplay(data) {
        if (data.response === "Success") {
            if (data.links.length > 0) {
                let i = 1;
                _.each(data.links, function (value) {
                    window.open(value, `document${i}`);
                    i++;
                });
            } else {
                var blob = base64ToBlob(data.base64Pod, "pdf");
                var url = window.URL.createObjectURL(blob);
                window.open(url);
            }
            submitModalFlow.hideAllModals();
        } else if (data.response === "Failure") {
            submitModalFlow.showFailureModal();
        } else{
            //Display no POD popup window
            noPODAvailableErrorModal.modal("show"); 
            submitModalFlow.hideAllModals();            
        }
    }

    function onFailureDisplay(data){
        submitModalFlow.showFailureModal();
      }

    function generateModals() {
        orderIdNumberModal = $(render(
            sharedModalHtml, {
                modalDialogClass: "q-modal-dialog-500",
                title: 'Order ID Number',
                leftAlignTitle: false,
                body: render(
                    modalOrderBody, {
                        shpPackageCount: packageCount
                    }
                ),
                topCloseBtn: true,
                autoHideTop: true,
                footerBtns: `<a href="#" class="base-btn purple-btn v2-btn cancel-deactivate-rule modal-auto-hide">Cancel</a>
          <a href="#" class="base-btn purple-btn go-to-summary-btn">Go to Summary</a>`
            }
        ));
        $("body").append(orderIdNumberModal);
    }

    function showOrderIdNumberModel() {
        orderIdNumberModal.modal("show");
    }

    function goToSummaryPage() {
        submitModalFlow.showLoadingModal();
        orderIdNumberModal.modal("hide");
        window.open(goToSummaryPageURL, "_self");
    }

    $('body').on('click', '.download-doc-row-btn', function (e) {
        e.preventDefault();
        let docId = $(this).closest('.download-doc-row-btn').data('document-id');
        if(shallAllowClick(this)){
            downloadFiles([docId], 'downloadByDocId');
        }
    });

    $('body').on('click', '.remove-doc-row-btn', function (e) {
        e.preventDefault();
        let docId = $(this).closest('.remove-doc-row-btn').data('document-id');
        if(shallAllowClick(this)){
            deleteFileByDocId([docId, shipShipmentNumber(), shipmentTrackingNumber(),shipmentBol(),facilityNo,wmOrderNo]);            
        }
    });

    function deleteFileByDocId(item) {
        let encodeDocId=encodeURIComponent(item[0]);
        let deleteFileUri = `${deleteFileByDocIdUrl}&documentId=${encodeDocId}&shpShipmentNumber=${item[1]}&shpTrackingNumber=${item[2]}&frightFlag=${frightFlag}&shpBol=${item[3]}&facilityNo=${item[4]}&wmOrderNo=${item[5]}`;
        submitModalFlow.showLoadingModal();
        $.ajax({
            url: deleteFileUri,
            type: 'POST',
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            cache: false,
            success: deleteFileSuccess,
            error: deleteFileError
        });
    }

    function deleteFileSuccess(resp) {
        if ($.trim(resp) == "true") {
            submitModalFlow.showSuccessModal();
            setTimeout(function () {
                location.reload();
            }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        } else {
            deleteFileError();
        }

    }

    function deleteFileError() {
        submitModalFlow.showFailureModal();
        setTimeout(function () {
            submitModalFlow.hideAllModals();
            submitModalFlow.showFailureModal();
        }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
    }

    $('body').on('click', '.download-shipping-doc-btn', function(e){
        e.preventDefault();
        if(shallAllowClick(this)){
            if(shipmentTrackingNumber() == 'Not Available' && frightFlag == '1'){
                downloadFiles([shipShipmentNumber(),shipmentBol()], 'downloadByShpInfo');
            }else{
                downloadFiles([shipShipmentNumber(),shipmentTrackingNumber()], 'downloadByShpInfo');
            }
            
        }
    });

    function downloadFiles(item, downloadSrc) {
        let downloadFileUri;
        let encodeDocId;
        if (downloadSrc == 'downloadByDocId'){
            encodeDocId=encodeURIComponent(item);
            downloadFileUri = `${downloadFileByDocIdUrl}&documentId=${encodeDocId}`;
        }else{
            encodeDocId=encodeURIComponent(item[0]);
            downloadFileUri = `${downloadFileUrl}&shpShipmentNumber=${encodeDocId}&shpTrackingNumber=${item[1]}&frightFlag=${frightFlag}&facilityNo=${facilityNo}&wmOrderNo=${wmOrderNo}`;
        }
        
        let formData = new FormData();
        formData.append("shpShipmentRow", "");
        submitModalFlow.showLoadingModal();
        $.ajax({
            url: downloadFileUri,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            cache: false,
            success: downloadFileSuccess,
            error: downloadFileError
        });
    }

    function downloadFileSuccess(data) {
        if (isPresent(data)) {
            $.each(JSON.parse(data), function (key, value) {
                if (value.contentType == "atd") {
                    value.contentType = "txt";
                }
                downloadFile(value.contentType, value.fileName, value.content);
            });
        } else {
            setTimeout(function () {
                submitModalFlow.hideAllModals();
                submitModalFlow.showFailureModal();
            }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        }

    }

    function downloadFileError() {
        submitModalFlow.showFailureModal();
        setTimeout(function () {
            submitModalFlow.hideAllModals();
            submitModalFlow.showFailureModal();
        }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
    }

    function downloadFile(mimeType, fileName, data) {
        var a = document.createElement('a');
        if (window.URL && window.Blob && ('download' in a) && window.atob) {
            // Do it the HTML5 compliant way
            var blob = base64ToBlob(data, mimeType);
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        }
        submitModalFlow.hideAllModals();
    }

    function base64ToBlob(base64, mimetype, slicesize) {
        if (!window.atob || !window.Uint8Array) {
            // The current browser doesn't have the atob function. Cannot continue
            return null;
        }
        mimetype = "application/" + mimetype || '';
        slicesize = slicesize || 512;
        var bytechars = atob(base64);
        var bytearrays = [];
        for (var offset = 0; offset < bytechars.length; offset += slicesize) {
            var slice = bytechars.slice(offset, offset + slicesize);
            var bytenums = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                bytenums[i] = slice.charCodeAt(i);
            }
            var bytearray = new Uint8Array(bytenums);
            bytearrays[bytearrays.length] = bytearray;
        }
        return new Blob(bytearrays, { type: mimetype });
    }

    function getStatusHistoryData() {
      const eventHistoryData = packageDetailsForm.shipment[0].evntHistory;
      const statusHistoryArray = _(eventHistoryData).map(buildStatusHistoryRow).join("");
      if (isPresent(statusHistoryArray)){
            return statusHistoryArray;
        } else {
            return render(shipmentHistoryMissingTemplate, "");
        }
    }

    function buildStatusHistoryRow(item) {
        return render(
            statusHistoryRowTemplate, {
                icon: getIcons(item.eventActivity),
                statusColor: getStatusColor(item.eventActivity),
                status: item.eventActivity,
                date: moment(item.eventDate).format("MM/DD/YYYY hh:mm A"),
                city: item.eventCity
            }
        );
    }

    function shipmentTrackingNumber() {
        const shipmentData = packageDetailsForm.shipment;
        if (isPresent(shipmentData)) {
            const shipmentTrackingNum = packageDetailsForm.shipment[0].trackingNumber;
            return shipmentTrackingNum;
        }
    }

    function shipmentBol() {
        const shipmentData = packageDetailsForm.shipment;
        if (isPresent(shipmentData)) {
            const shipmentBol = packageDetailsForm.shipment[0].shipBol;
            return shipmentBol;
        }
    }

    function shipShipmentNumber() {
        const shipmentData = packageDetailsForm.shipment;
        if (isPresent(shipmentData)) {
            const shipmentNumber = packageDetailsForm.shipment[0].shipShipmentNumber;
            return shipmentNumber;
        }
    }

    function shipperCarrier() {
        const shipmentData = packageDetailsForm.shipment;
        if (isPresent(shipmentData)) {
            const shipperCarrier = packageDetailsForm.shipment[0].shipperCarrier;
            return shipperCarrier;
        }
    }

    function shipmentShipDate() {
        const shipmentData = packageDetailsForm.shipment;
        if (isPresent(shipmentData)) {
            const shipDate = moment(packageDetailsForm.shipment[0].shipDate).format("MM/DD/YYYY hh:mm A");
            return shipDate;
        }
    }

    function shipmentStatusrenderRow() {
        const shipmentStatusrenderData = packageDetailsForm.shipment;
        if (isPresent(shipmentStatusrenderData)) {
            const shipmentStatusrenderArray = _(shipmentStatusrenderData).map(shipmentStatusrenderRowTemp);
            return shipmentStatusrenderArray;
        }
    }

    
    function getStatus (shipStatus){
      var str = new Array();
      if (shipStatus == null){
        str[0] = "Voided";
      }else if (shipStatus.startsWith("Delivered")) {
        str = shipStatus.split("-");
      } else {
        str[0] = shipStatus;
      }
      return str;
    }

    function shipmentStatusrenderRowTemp(shipmentStatusdata) {
        var str = getStatus (shipmentStatusdata.shpStatus);
        let latestEventDate = "";
        
        //Get the latest date from event history array.If not show shpmodifieddate else show shpcreateddate
        if(! ((shipmentStatusdata.evntHistory)=== undefined ) && (shipmentStatusdata.evntHistory).length>0){
            latestEventDate = getLatestEventDateTime(shipmentStatusdata.evntHistory);
        }
        if(isBlank(latestEventDate)){
            if (shipmentStatusdata.shipModifiedDate != null){
                latestEventDate = shipmentStatusdata.shipModifiedDate;
            }else{
                latestEventDate = shipmentStatusdata.shipCreatedDate;
            }    
        }
        return render(
            statusRowTemplate, {
                icon: getIcons(str[0].trim()),
                statusColor: getStatusColor(str[0].trim()),
                status: str[0].trim(),
                status2: (str[1] != null ? str[1]:" "),
                date: moment(latestEventDate).format("MM/DD/YYYY hh:mm A"),
                city: shipmentStatusdata.recipientCity,
                recipientName: shipmentStatusdata.recipientName,
                podBtnStatus: (str[0].trim() === "Delivered") ? '' : 'disabled'
            }
        );
    }

    function getLatestEvent(eventArray) {
        return _.max(eventArray, function(eachEvent) {
            return eachEvent.eventTime
        });
    }

    function getLatestEventDateTime(eventHistoryArray) {
        let eventDateArray = [];        
        //Get each event date and prepare list
         (eventHistoryArray).forEach(function(element, index) {
           eventDateArray.push(new Date(element.eventTime));
          });

          //return the latest datetime from the list
          if(!(eventDateArray === undefined)  && eventDateArray.length != 0 ){
            return _.max(eventDateArray);
          }
    }

    function shipmentDetailsRow() {
        const shipmentDetailsRowData = packageDetailsForm.shipment;
        if (isPresent(shipmentDetailsRowData)) {
            const shipmentDetailsRowArray = _(shipmentDetailsRowData).map(shipmentDetailsRowTemp);
            return shipmentDetailsRowArray;
        }
    }

    function shipmentDetailsRowTemp(shpDetailsRow) {
        return render(
            shipmentDetailsRowTemplate, {
                trackingNumber: shpDetailsRow.trackingNumber,
                shipperOrderId: shpDetailsRow.OrderId,
                shpPackageCount: packageCount,
                shipperCarrier: shpDetailsRow.shipperCarrier
            }
        );
    }

    function shippingDocSectionRow() {
        return render(
            shippingDocSectionRowTemplate, {
                fileNameArea: getShpDocFilesData()
            }
        );
    }

    function getShpDocFilesData() {
        const shpDocFilesArray = _(shpDocDetails).map(buildShpDocFilesRow).join("");
        if (isPresent(shpDocFilesArray)) {
            $(".download-shipping-doc-btn").removeClass('disabled');
            return shpDocFilesArray;
        } else {
            $(".download-shipping-doc-btn").addClass('disabled');
            return render(fileNameRowMissingTemplate, "");
        }
    }

    function buildShpDocFilesRow(item) {
        return render(
            shippingDocFileNameRowTemplate, {
                fileName: item.fileName,
                fileUploadDate: moment(item.uploadDate).format("MM/DD/YYYY hh:mm A"),
                documentId: item.documentId
            }
        );
    }

    function deliveryDetailsRow() {
        const deliveryDetailsRowData = packageDetailsForm.shipment;
        if (isPresent(deliveryDetailsRowData)) {
            const deliveryDetailsRowArray = _(deliveryDetailsRowData).map(deliveryDetailsRowTemp);
            return deliveryDetailsRowArray;
        }
    }

    function deliveryDetailsRowTemp(delryDetailsRow) {
        return render(
            deliveryDetailsRowTemplate, {
                shipper: delryDetailsRow.shipper,
                shipperName: delryDetailsRow.shipperName,
                shipperAddressLine1: delryDetailsRow.shipperAddressLine1,
                shipperAddressLine2: delryDetailsRow.shipperAddressLine2,
                shipperCity: delryDetailsRow.shipperCity,
                shipperState: delryDetailsRow.shipperState,
                shipperCountry: delryDetailsRow.shipperCountry,
                shipperPostalCode: delryDetailsRow.shipperPostalCode,
                recipientName: delryDetailsRow.recipientName,
                recipientAddressLine1: delryDetailsRow.recipientAddressLine1,
                recipientAddressLine2: delryDetailsRow.recipientAddressLine2,
                recipientCity: delryDetailsRow.recipientCity,
                recipientState: delryDetailsRow.recipientState,
                recipientCountry: delryDetailsRow.recipientCountry,
                recipientPostalCode: delryDetailsRow.recipientPostalCode
            }
        );
    }

    function getIcons(shpStatus) {
        if (shpStatus === "Delivered") {
            return "check"
        } else if (shpStatus === "Pre-Pickup") {
            return "cube";
        } else if (shpStatus === "InTransit") {
            return "truck";
        } else if (shpStatus === "Out for Delivery") {
            return "truck";
        } else if (shpStatus === "Voided") {
            return "close";
        } else if (shpStatus === "Shipment Exception") {
            return "truck";
        } else if (shpStatus === "Delivery Exception") {
            return "exclamation";
        } else if (shpStatus === "Return Exception") {
            return "reply";
        } else if (shpStatus === "Shipped") {
            return "truck";
        } else {
            return "cube";
        }
    }

    function getStatusColor(shpStatus) {
        if (shpStatus == "Delivered") {
            return "green"
        } else if (shpStatus == "Pre-Pickup") {
            return "more-light-grey";
        } else if (shpStatus == "InTransit") {
            return "more-light-grey";
        } else if (shpStatus == "Out for Delivery") {
            return "blue";
        } else if (shpStatus == "Voided") {
            return "more-light-grey";
        } else if (shpStatus == "Shipment Exception") {
            return "red";
        } else if (shpStatus == "Delivery Exception") {
            return "red";
        } else if (shpStatus == "Return Exception") {
            return "red";
        } else if (shpStatus == "Shipped") {
            return "blue";
        } else {
            return "blue";
        }
    }

    function generateSharedModal(){
        shipmentDocsFileUploadModal = $(render(
          modalHtml,
          {
            title: ' Upload Shipping Documents',
            leftAlignTitle: true,
            body: uploadShippingDocsModalBodyHtml,
            modalDialogClass: "q-modal-dialog-800",
            topCloseBtn: true,
            autoHideTop: true,
            footerBtns: `
            <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a>
            <a  href="#" class="base-btn purple-btn custom-submit-btn upload-selected-files disabled">Upload Selected</a>
            `
          }
          ));
          $("body").append(shipmentDocsFileUploadModal);

          let shipDocsFileUploader = new fileUploader({
            target: '.ship-docs-file-uploader-body',
            accept: ['.xls','.xlsx','.doc','.docx','.pdf','.tiff','.tif','.jpg','.jpeg','.gif','.txt','.csv'],
            multiple: true,
            maxFileSize: 10,
            afterValidSelection : function(){
              shipmentDocsFileUploadModal.find(".upload-selected-files").removeClass("disabled");
            },
            afterInvalidSelection : function(){
              shipmentDocsFileUploadModal.find(".upload-selected-files").addClass("disabled");
            }
          });

        shipDocsFileUploader.init();
        shipmentDocsFileUploadModal.modal("show");

        if(shallAllowClick(this)){
          $(".upload-selected-files").on('click',()=>{
            submitModalFlow.showLoadingModal();
            sendFiles(shipDocsFileUploader.getFiles());
          });
        }
        shipmentDocsFileUploadModal.on('hidden.bs.modal', function (e) {
          shipmentDocsFileUploadModal.remove();
        });

      }

    function sendFiles(fileList){
         shipmentDocsFileUploadModal.modal("hide");
         let formData = new FormData();
         fileList.forEach(file=>{formData.append("files[]", file)});
         formData.append("shpShipmentRow", "");
         let uploadUri = `${uploadFileUrl}&shpTrackingNumber=${shipmentTrackingNumber()}&shpShipmentNumber=${shipShipmentNumber()}&frightFlag=${frightFlag}&shipmentBol=${shipmentBol()}`;
         
        $.ajax({
          url: uploadUri,
          type: 'POST',
          data: formData,
          enctype: 'multipart/form-data',
          processData: false,
          contentType: false,
          cache: false,
          success: sendFileSuccess,
          error: sendFileError
        });
      }

    function sendFileSuccess(resp){
          if($.trim(resp)=="true"){
            shipmentDocsFileUploadModal.modal("hide");
            submitModalFlow.showSuccessModal();
            setTimeout(function() {
              location.reload();
            }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
          }else{
            sendFileError();
          }

      }

    function sendFileError(){
        submitModalFlow.hideAllModals();
        shipmentDocsFileUploadModal.find(".upload-error").show();
      }

    $("#backToListBtn").on("click", function() {
        window.open(backToList, "_self");
    });

    $("#searchAgainBtn").on("click", function() {
        window.open(backTosearch, "_self");
    });


    init();
});



// WEBPACK FOOTER //
// ./src/pages/proofOfDelivery/podPackageDetailsScreen/packageDetails.js